import { render, staticRenderFns } from "./messagePopup.vue?vue&type=template&id=004f17e0&scoped=true"
import script from "./messagePopup.vue?vue&type=script&lang=js"
export * from "./messagePopup.vue?vue&type=script&lang=js"
import style0 from "./messagePopup.vue?vue&type=style&index=0&id=004f17e0&prod&lang=scss&scoped=true"
import style1 from "./messagePopup.vue?vue&type=style&index=1&id=004f17e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004f17e0",
  null
  
)

export default component.exports